/* eslint-disable no-console */
import addSeconds from "date-fns/addSeconds";
import {
  AuthActionCreators,
  LoanActionCreators,
  NewFormActionCreators,
  RegistrationActionCreators,
} from "../../store/action-creators";
import {
  AccountApi,
  AdditionalQuestionsApi,
  DictionariesApi,
  DocumentRulesApi,
  FinancingApi,
  OfferApi,
  PassportApi,
  ProductApi,
  RegistrationApi,
  ScanApi,
} from "../agent";
import { authApi } from "../authApi";

export const sendPassportThunk = (passportData) => async (dispatch) => {
  try {
    const response = await PassportApi.sendPassport(passportData);

    if (!response.result) {
      dispatch(
        NewFormActionCreators.setErrors({
          isError: true,
          errorCode: response?.errorCode,
          errorMessage: response?.errorMessage,
        })
      );
      dispatch(NewFormActionCreators.setResult(response?.result));
    } else {
      dispatch(NewFormActionCreators.setResult(response?.result));
      dispatch(NewFormActionCreators.setIsPassport(true));
    }
    return response;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const setAddressDataThunk =
  ({ applicationId, registrationAddress, residenceAddress }) =>
  async (dispatch) => {
    try {
      const data = {
        applicationId,
        registrationAddress,
        residenceAddress: residenceAddress || registrationAddress,
      };

      const response = await PassportApi.sendAddressData(data);

      if (!response?.response) {
        dispatch(
          NewFormActionCreators.setErrors({
            isError: true,
            errorCode: response?.errorCode,
            errorMessage: response?.errorMessage,
          })
        );
      } else {
        dispatch(NewFormActionCreators.setIsAddress(true));
      }
      dispatch(NewFormActionCreators.setResult(response?.result));

      return response;
    } catch (e) {
      dispatch(
        NewFormActionCreators.setErrors({
          isError: true,
          errorCode: -1,
          errorMessage: e.message,
        })
      );
      return null;
    }
  };

export const sendWorkDataThunk = (workData) => async (dispatch) => {
  try {
    const response = await PassportApi.sendWorkData(workData);

    if (!response?.result) {
      dispatch(
        NewFormActionCreators.setErrors({
          isError: true,
          errorCode: response?.errorCode,
          errorMessage: response?.errorMessage,
        })
      );
      dispatch(NewFormActionCreators.setResult(response?.result));
    } else {
      dispatch(NewFormActionCreators.setResult(response?.result));
      dispatch(NewFormActionCreators.setIsWork(true));
    }
    return response;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const getCalculatorSettingsThunk =
  ({ applicationId, useSmartCalculator }) =>
  async (dispatch) => {
    try {
      const response = await ProductApi.getCalculatorSettings(
        applicationId,
        useSmartCalculator
      );
      if (response) {
        dispatch(NewFormActionCreators.setCalculatorSettings(response));
        dispatch(
          NewFormActionCreators.setProductId(
            response?.selectedProduct?.productId
          )
        );
        dispatch(
          LoanActionCreators.setRefundAmount(
            response?.selectedProduct?.fullOfferSum
          )
        );
        dispatch(
          LoanActionCreators.setLoanAmount(response?.selectedProduct?.offerSum)
        );
        dispatch(
          LoanActionCreators.setTermAmount(
            response?.selectedProduct?.offerPeriod
          )
        );
        dispatch(
          LoanActionCreators.setPeriodType(
            response?.selectedProduct?.periodTypeId
          )
        );
        if (
          typeof response?.selectedProduct?.fullOfferSum === "number" &&
          typeof response?.selectedProduct?.offerSum === "number"
        ) {
          dispatch(
            LoanActionCreators.setOverpaymentAmount(
              response.selectedProduct.fullOfferSum -
                response.selectedProduct.offerSum
            )
          );
        }
        dispatch(
          LoanActionCreators.setPaymentAmount(
            response?.selectedProduct?.paymentAmount
          )
        );
      } else {
        dispatch(
          NewFormActionCreators.setErrors({
            isError: true,
            errorCode: response?.errorCode,
            errorMessage: response?.errorMessage,
          })
        );
      }
      return response;
    } catch (e) {
      console.error(e);
      return null;
    }
  };

export const getDefaultCalculatorSettingsThunk = (data) => async (dispatch) => {
  try {
    dispatch(LoanActionCreators.setLoading(true));

    const response = await ProductApi.getDefaultCalculatorSettings.call(data);
    if (response?.result) {
      dispatch(
        RegistrationActionCreators.setDefaultCalculatorSettings(response?.data)
      );
      dispatch(LoanActionCreators.setRefundAmount(response?.data?.fullSum));
      dispatch(LoanActionCreators.setLoanAmount(response?.data?.defaultSum));
      dispatch(LoanActionCreators.setTermAmount(response?.data?.defaultPeriod));
      dispatch(
        LoanActionCreators.setPeriodType(response?.data?.defaultTypePeriod)
      );
      dispatch(
        LoanActionCreators.setOverpaymentAmount(response?.data?.overpaymentSum)
      );
    }
    return response;
  } catch (e) {
    console.error(e);
    return null;
  } finally {
    dispatch(LoanActionCreators.setLoading(false));
  }
};

export const sendAdditionalQuestions = (data) => async () => {
  const values = data;

  try {
    if (values.claimAimId === "") {
      values.claimAimId = "0b42f0dd-1ab4-447b-8d88-4db918beedfd";
    }
    if (values.financialAimId === "") {
      values.financialAimId = "e37350be-fe6e-4357-a6ea-4237e8f59fdc";
    }
    if (values.financialPositionId === "") {
      values.financialPositionId = "ad03fc0a-0e94-4f42-b7f1-25f0baf0ea1f";
    }
    if (values.relationToInsolventId === "") {
      values.relationToInsolventId = "c3eee943-1996-45b5-a962-3e73d7fea036";
    }
    if (values.reputationRatingId === "") {
      values.reputationRatingId = "30ae50c3-6c4f-46d9-9086-a75e955e0f50";
    }
    const response =
      await AdditionalQuestionsApi.setAdditionalQuestions(values);

    return response;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const getAdditionalQuestionsDictionary = () => async (dispatch) => {
  try {
    const result =
      await AdditionalQuestionsApi.getAdditionalQuestionsDictionary();

    if (!result.result)
      throw new Error("Ошибка при получения словаря дополнительных вопросов.");
    dispatch(
      NewFormActionCreators.setAdditionalQuestionsDictionary(result?.data)
    );
  } catch (e) {
    console.error(e);
  }
};

export const getAdditionalQuestionsThunk = () => async () => {
  try {
    const result = await AdditionalQuestionsApi.getAdditionalQuestions();
    if (!result.result)
      throw new Error("Ошибка при получения дополнительных вопросов.");
    return result;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const getDictionariesThunk = (catalogs) => async (dispatch) => {
  try {
    const response = await DictionariesApi.getDictionaries(catalogs);

    if (response) {
      dispatch(NewFormActionCreators.setDictionaries(response?.dictionaries));
    } else {
      dispatch(
        NewFormActionCreators.setErrors({
          isError: true,
          errorCode: response?.errorCode,
          errorMessage: response?.errorMessage,
        })
      );
    }
  } catch (e) {
    console.error(e);
  }
};

export const sendCalculatorSettings =
  (calcData, { fastPrefetch = false } = {}) =>
  async (dispatch) => {
    try {
      const apiMethod = fastPrefetch
        ? ProductApi.getCurrentSelectProductResult
        : ProductApi.setCalculatorSettings;
      const response = await apiMethod.call({
        ...calcData,
        excludeCalculatorSettings: true,
      });

      if (response?.result) {
        dispatch(LoanActionCreators.setRefundAmount(response?.fullOfferSum));
        dispatch(LoanActionCreators.setLoanAmount(response?.offerSum));
        dispatch(LoanActionCreators.setTermAmount(response?.offerPeriod));
        dispatch(LoanActionCreators.setPeriodType(response?.periodTypeId));
        if (
          typeof response?.fullOfferSum === "number" &&
          typeof response?.offerSum === "number"
        ) {
          dispatch(
            LoanActionCreators.setOverpaymentAmount(
              response.fullOfferSum - response.offerSum
            )
          );
        }
        dispatch(LoanActionCreators.setPaymentAmount(response?.paymentAmount));
        dispatch(NewFormActionCreators.setProductId(response?.productId));
      } else {
        dispatch(
          NewFormActionCreators.setErrors({
            isError: true,
            errorCode: response?.errorCode,
            errorMessage: response?.errorMessage,
          })
        );
      }
    } catch (e) {
      console.error(e);
    }
  };

export const loginThunk =
  ({ phone, birthDate, captchaV3, captchaV2 }) =>
  async (dispatch) => {
    try {
      const response = await authApi.authWithPhoneAndBirthdate({
        payload: {
          phone,
          birthDate,
          captchaV3,
          captchaV2,
        },
      });

      if (response?.result) {
        dispatch(
          AuthActionCreators.setAuthData({
            phone,
            birthDate,
          })
        );
        dispatch(AuthActionCreators.setCodeId(response.codeId));
        const expires = addSeconds(new Date(), response.resendTimeLeft);
        dispatch(AuthActionCreators.setCodeExpires(expires));
      }
      return response;
    } catch (e) {
      console.error(e);
      return null;
    }
  };

export const checkRegistrationCodeThunk = (data) => async () => {
  const response = await RegistrationApi.checkCode(data);

  return response.data;
};

export const resendRegistrationCodeThunk = (data) => async (dispatch) => {
  const response = await RegistrationApi.resendCode(data);
  if (!response?.data?.result) {
    dispatch(
      RegistrationActionCreators.setRegistrationErrors({
        isError: true,
        errorCode: response?.data?.errorCode,
        errorMessage: response?.data?.errorMessage,
      })
    );
  } else {
    dispatch(
      RegistrationActionCreators.setRegistrationCodes({
        codeId: response.data.codeId,
      })
    );
  }
  return response.data;
};

export const createTempContactThunk = (query) => async (dispatch) => {
  try {
    const response = await RegistrationApi.sendCode(query);
    if (!response?.data?.result) {
      dispatch(
        RegistrationActionCreators.setRegistrationErrors({
          isError: true,
          errorCode: response?.data?.errorCode,
          errorMessage: response?.data?.errorMessage,
        })
      );
    }
    return response;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const createContactThunk = (query) => async (dispatch) => {
  try {
    const response = await RegistrationApi.createContact(query);

    if (!response?.data?.result) {
      dispatch(
        RegistrationActionCreators.setRegistrationErrors({
          isError: true,
          errorCode: response?.data?.errorCode,
          errorMessage: response?.data?.errorMessage,
        })
      );
    }
    return response;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const removeScanThunk = (id) => async () => {
  try {
    const response = await ScanApi.removeScan(id);

    return response;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const checkIfScanIsRequiredThunk = (query) => async () => {
  try {
    const response = await ScanApi.checkIfScanIsRequired(query);

    return response;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const usePromoCodeThunk = (data) => async () => {
  try {
    const response = await AccountApi.usePromoCode(data);

    return response;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const getPromocodeInfoThunk = (applicationId) => async () => {
  try {
    const response = await AccountApi.getPromocodeInfo(applicationId);

    return response;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const cancelPromocodeThunk = (applicationId) => async () => {
  try {
    const response = await AccountApi.cancelPromocode(applicationId);

    return response;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const saveToApplicationThunk = (data) => async () => {
  try {
    const response = await FinancingApi.saveFinInstrumentToApplication(data);

    return response;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const checkIfHasSynonimThunk = (id) => async () => {
  try {
    const response = await FinancingApi.checkIfHasSynonim(id);

    return response;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const saveRepresentativeThunk = (data) => async () => {
  try {
    const response = await AdditionalQuestionsApi.saveRepresentative(data);
    return response;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const saveBeneficiaryThunk = (data) => async () => {
  try {
    const response = await AdditionalQuestionsApi.saveBeneficiary(data);
    return response;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const saveBeneficiaryOwnerThunk = (data) => async () => {
  try {
    const response = await AdditionalQuestionsApi.saveBeneficiaryOwner(data);
    return response;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const savePublicOfficialThunk = (data) => async () => {
  try {
    const response = await AdditionalQuestionsApi.savePublicOfficial(data);
    return response;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const saveRelativeThunk = (data) => async () => {
  try {
    const response = await AdditionalQuestionsApi.saveRelative(data);
    return response;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const redirectToLkThunk = (url) => async () => {
  try {
    const response = await AccountApi.redirectToLk({ url });
    return response;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const checkCodeThunk = (data) => async () => {
  try {
    const { codeId, code } = data;
    const response = await authApi.checkOTPCode({
      payload: {
        codeId,
        code,
      },
    });

    return response;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const signInThunk = (data) => async () => {
  try {
    const {
      cookie,
      codeId,
      code,
      requestedOfferSum,
      requestedOfferPeriod,
      periodTypeId,
    } = data;
    const response = await AccountApi.accountSignIn({
      cookie,
      codeId,
      code,
      requestedOfferSum,
      requestedOfferPeriod,
      periodTypeId,
    });

    return response;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const signOutThunk = () => async () => {
  try {
    await authApi.signOut();
  } catch (e) {
    console.error(e);
  }
};

export const getDocumentsForRegistrationThunk = () => async () => {
  try {
    const response = await DocumentRulesApi.documentsForRegistration();

    return response;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const getDocumentsForPageThunk = (body) => async () => {
  try {
    const response = await DocumentRulesApi.documentsForPage(body);

    return response;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const getSynonimThunk = (data) => async () => {
  try {
    const response = await FinancingApi.getSynonim(data);

    return response;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const sendCodeDoUpridThunk = (id) => async () => {
  try {
    const response = await AccountApi.sendCodeDoUprid(id);

    return response;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const checkUpridCodeThunk = (data) => async () => {
  try {
    const response = await AccountApi.checkUpridCode(data);

    return response;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const getDecisionApplicationThunk = (id) => async () => {
  try {
    const response = await OfferApi.getDecisionApplication(id);

    return response;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const removeRepresentativeThunk = () => async () => {
  try {
    const response = await AdditionalQuestionsApi.removeRepresentative();

    return response;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const removeBeneficiaryThunk = () => async () => {
  try {
    const response = await AdditionalQuestionsApi.removeBeneficiary();

    return response;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const removeBeneficiaryOwnerThunk = () => async () => {
  try {
    const response = await AdditionalQuestionsApi.removeBeneficiaryOwner();

    return response;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const removePublicOfficialThunk = () => async () => {
  try {
    const response = await AdditionalQuestionsApi.removePublicOfficial();

    return response;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const removeRelativeThunk = () => async () => {
  try {
    const response = await AdditionalQuestionsApi.removeRelative();

    return response;
  } catch (e) {
    console.error(e);
    return null;
  }
};
